import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, PlusCircle, History, Truck, Users, FileBarChart, ShieldCheck, Tv, LogOut, Ship } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

const NAV = [
  { to: "/", label: "Panel", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/registro", label: "Registrar", icon: PlusCircle, testid: "nav-registro" },
  { to: "/historial", label: "Historial", icon: History, testid: "nav-historial" },
  { to: "/camiones", label: "Camiones", icon: Truck, testid: "nav-camiones" },
  { to: "/conductores", label: "Conductores", icon: Users, testid: "nav-conductores" },
  { to: "/reportes", label: "Reportes", icon: FileBarChart, testid: "nav-reportes" },
  { to: "/transito", label: "Tránsito", icon: Ship, testid: "nav-transito" },
];

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      isActive ? "bg-white/10 text-telemetry" : "text-slate-300 hover:bg-white/5 hover:text-white"}`;

  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      <aside className="hidden md:flex w-60 flex-col bg-navy text-white fixed inset-y-0 z-30">
        <div className="p-5 border-b border-white/10">
          <Logo dark />
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} end={to === "/"} className={linkCls} data-testid={testid}>
              <Icon className="w-4.5 h-4.5 w-5 h-5" /> {label}
            </NavLink>
          ))}
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin">
              <ShieldCheck className="w-5 h-5" /> Administración
            </NavLink>
          )}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <NavLink to="/tv" className={linkCls} data-testid="nav-tv">
            <Tv className="w-5 h-5" /> Vista TV
          </NavLink>
          <button onClick={handleLogout} data-testid="logout-button"
                  className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:bg-white/5 hover:text-white transition-colors">
            <LogOut className="w-5 h-5" /> Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex-1 md:ml-60 flex flex-col min-h-screen">
        <header className="md:hidden sticky top-0 z-20 bg-navy text-white px-4 py-3 flex items-center justify-between">
          <Logo dark size="sm" />
          <div className="flex items-center gap-2">
            <span className="text-xs text-slate-300">{user?.name}</span>
            <button onClick={handleLogout} data-testid="logout-button-mobile" className="p-2 text-slate-300 hover:text-white">
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </header>

        <main className="flex-1 p-4 md:p-8 pb-24 md:pb-8 max-w-7xl w-full mx-auto">
          <Outlet />
        </main>

        <div className="hidden md:block pb-2">
          <Footer />
        </div>

        <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-navy border-t border-white/10 grid grid-cols-7 px-1 py-1.5">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} end={to === "/"} data-testid={`${testid}-mobile`}
                     className={({ isActive }) =>
                       `flex flex-col items-center gap-0.5 py-1.5 rounded-md text-[10px] font-medium transition-colors ${
                         isActive ? "text-telemetry" : "text-slate-400"}`}>
              <Icon className="w-5 h-5" /> {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
